import(/* webpackMode: "eager" */ "/opt/cal-diy/apps/web/app/global-error.tsx");
